import { useState } from "react";
import { Box, Divider, Grid, Link, Paper, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import StyledButton from "../../components/reusable/StyledButton";
import { ReactComponent as ToastLogo } from '../../SVG/ToastLogo.svg'
import { ReactComponent as UberLogo } from '../../SVG/uber_eats_logo.svg'
import StyledSvgIcon from "../../components/reusable/StyledSvgIcon";
import theme from "../../constants/theme";
import StyledDialog from "../../components/reusable/StyledDialog";
import Pattern from '../../images/wordcollage_shadow_light.avif'

const apikey = process.env.REACT_APP_GOOGLE_API_KEY
const admiralsPlaceID = process.env.REACT_APP_ADMIRALS_PLACE_ID
const royalOakPlaceID = process.env.REACT_APP_ROYAL_OAK_PLACE_ID
const WestshorePlaceId = process.env.REACT_APP_WESTSHORE_PLACE_ID

const useStyles = makeStyles()((theme) => ({
  orderContainer: {
    backgroundImage: `linear-gradient(90deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(${Pattern})`, 
    backgroundRepeat: 'repeat', 
    backgroundPosition: 'center', 
    backgroundSize: '40%'
  },
  animatedBorder: {
    border: '0.3rem solid transparent',
    borderRadius: '16px',
    backgroundSize: '300% 100%',

    '@keyframes borderShift': {
      '0%': {
        backgroundPosition: '0% 50%',
      },
      '100%': {
        backgroundPosition: '300% 0%',
      },
    },
  },
  hoursContainer: {
    paddingTop: '32px',
    paddingBottom: '32px',
    marginTop: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: '60vw',

    animation: 'borderShift 8s linear infinite',
    background: `
      linear-gradient(white) padding-box,
      linear-gradient(
        90deg,
        #165FAB, #60A5FA, #dbebff, #60A5FA, #165FAB
      ) border-box
    `,

    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  admiralsMapBox: {
    animation: 'borderShift 5s linear infinite',
    background: `
      linear-gradient(white) padding-box,
      linear-gradient(
        90deg,
        #165FAB 0%,  #60A5FA 25%, #95d8ff 50%, #60A5FA 75%, #165FAB 100%
      ) border-box
    `
  },
  royalOakMapBox: {
    animation: 'borderShift 5s linear infinite',
    background: `
      linear-gradient(white) padding-box,
      linear-gradient(
        90deg,
      #611ffa,  #7b45f8, #ae8cfd, #7b45f8, #611ffa
      ) border-box
    `
  },
  westshoreMapBox: {
    animation: 'borderShift 5s linear infinite',
    background: `
      linear-gradient(skyblue) padding-box,
      linear-gradient(
        90deg,
        #ffd350,  #ffdd76, #fff2cc, #ffdd76, #ffd350
      ) border-box
    `
  }
}))

export default function Order() {
  const { classes } = useStyles();
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null)
  const [orderType, setOrderType] = useState<string | null>(null)

  return (
    <>

      {/* Subtitle and Hours */}
      <Box className={classes.orderContainer}>
          {/* Page Title */}
          <Grid
            container 
            size={{xs: 12}} 
            spacing={2} 
            sx={{
              padding: {xs: 3, md: 5},
              // background: `linear-gradient(180deg, rgba(255, 220, 115, 0.3), rgba(255, 212, 80, 0.4), 70%, rgba(255, 212, 80, 0.9))`,
            }}
          >
            <Grid size={{xs: 12}} sx={{textAlign: 'center', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', textTransform: 'uppercase'}}>
              <Typography variant="h1">Guyro. Geero. Jeero. Jyro.</Typography>
            </Grid>
            <Grid size={{xs: 12}} sx={{textAlign: 'center'}}>
              <Typography variant="h3">
                No wrong way to say it.
              </Typography>
              <Typography variant="h3">
                Only right ways to order it.
              </Typography>
            </Grid>
          </Grid>

        <Grid container spacing={{xs: 2, md: 8}} sx={{padding: {xs: 3, md: 5}}}>

          <Grid size={{xs: 12}} sx={{textAlign: 'center'}}>
            <Typography variant="h2" sx={{textDecoration: 'underline', textAlign: 'center', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', textTransform: 'uppercase'}}>Locations</Typography>
          </Grid>

          {/* Locations Grid */}
          <Grid size={{xs: 12, md: 5}} sx={{justifyContent: 'center', margin: 'auto'}} >
            <Paper sx={{aspectRatio: '1/1', display: 'flex'}} className={`${classes.admiralsMapBox} ${classes.animatedBorder}`}>
              <iframe
                width="100%"
                height="100%"
                style={{border:'0', borderRadius: '13px'}}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${apikey}&q=place_id:${admiralsPlaceID}`}
                allowFullScreen
              />
            </Paper>
            <Box sx={{textAlign: 'center'}}>
              <Grid
                container
                className={`${classes.hoursContainer} ${classes.animatedBorder}`}
                spacing={0}
              >
                <Grid size={{xs: 12}} sx={{textAlign: 'center'}}>
                  <Typography variant="h2">Proudly Serving You From:</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Monday-Saturday </Typography>
                  <Divider/>
                  <Typography variant="h3">11am - 9pm</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Sunday</Typography>
                  <Divider/>
                  <Typography variant="h3">11am - 7pm</Typography>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="body1" sx={{textAlign: 'center', color: "#60A5FA"}}>Admirals</Typography>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Typography variant="body1">Call In: &nbsp;</Typography>
              <Link underline="hover" variant='body1' sx={{textAlign: 'center', color: "#60A5FA"}} component='a' href="tel:250-380-2555">250-380-2555</Link>
            </Box>
            <Divider variant="middle" sx={{mb: 2}}>
              <StyledButton 
                onClick={() => 
                  {
                    setSelectedLocation('Admirals')
                    setOrderType('pickup')
                  }
                }
                fullWidth={false}
                endIcon={<StyledSvgIcon component={ToastLogo} viewBox="0 0 1498 1464" />}
                variant='contained'
                size="large"
              >
                Order Pickup
              </StyledButton>
            </Divider>
            <Divider variant="middle">
              <StyledButton 
                onClick={() => 
                  {
                    setSelectedLocation('Admirals')
                    setOrderType('delivery')
                  }
                }                fullWidth={false}
                endIcon={<StyledSvgIcon component={UberLogo} viewBox="219.8 0 160.4 159.9" />}
                variant='contained'
                size="large"
              >
                Order Delivery
              </StyledButton>
            </Divider>
          </Grid>

          <Grid size={{xs: 12, md: 5}} sx={{justifyContent: 'center', margin: 'auto'}} >
            <Paper sx={{aspectRatio: '1/1', display: 'flex'}} className={`${classes.royalOakMapBox} ${classes.animatedBorder}`}>
              <iframe
                width="100%"
                height="100%"
                style={{border:'0', borderRadius: '13px'}}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${apikey}&q=place_id:${royalOakPlaceID}`}
                allowFullScreen
              />
            </Paper>
            <Box sx={{textAlign: 'center'}}>
              <Grid
                container
                className={`${classes.hoursContainer} ${classes.animatedBorder}`}
                spacing={0}
              >
                <Grid size={{xs: 12}} sx={{textAlign: 'center'}}>
                  <Typography variant="h2">Proudly Serving You From:</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Monday-Saturday </Typography>
                  <Divider/>
                  <Typography variant="h3">11am - 9pm</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Sunday</Typography>
                  <Divider/>
                  <Typography variant="h3">11am - 7pm</Typography>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="body1" sx={{textAlign: 'center', color: "#7b45f8"}}>Royal Oak</Typography>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Typography variant="body1">Call In: &nbsp;</Typography>
              <Link underline='hover' variant='body1'  component='a' href="tel:250-704-0020" sx={{textAlign: 'center', color: "#7b45f8"}}>250-704-0020</Link>
            </Box>
            <Divider variant="middle" sx={{mb: 2}}>
              <StyledButton
                onClick={() => 
                  {
                    setSelectedLocation('Royal Oak')
                    setOrderType('pickup')
                  }
                }                
                fullWidth={false}
                endIcon={<StyledSvgIcon component={ToastLogo} viewBox="0 0 1498 1464" />}
                variant='contained' 
                size="large"
              >
                Order Pickup
              </StyledButton>
            </Divider>
            <Divider variant="middle">
              <StyledButton
                onClick={() => 
                  {
                    setSelectedLocation('Royal Oak')
                    setOrderType('delivery')
                  }
                }                
                fullWidth={false}
                endIcon={<StyledSvgIcon component={UberLogo} viewBox="219.8 0 160.4 159.9"/>}
                variant='contained' 
                size="large"
              >
                Order Delivery
              </StyledButton>
            </Divider>
          </Grid>

          <Grid size={{xs: 12, md: 5}} sx={{justifyContent: 'center', margin: 'auto'}} >
            <Paper sx={{aspectRatio: '1/1', display: 'flex'}} className={`${classes.westshoreMapBox} ${classes.animatedBorder}`}>
              <iframe
                width="100%"
                height="100%"
                style={{border:'0', borderRadius: '13px'}}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${apikey}&q=place_id:${WestshorePlaceId}`}
                allowFullScreen
              />
            </Paper>
            <Box sx={{textAlign: 'center'}}>
              <Grid
                container
                className={`${classes.hoursContainer} ${classes.animatedBorder}`}
                spacing={0}
              >
                <Grid size={{xs: 12}} sx={{textAlign: 'center'}}>
                  <Typography variant="h2">Proudly Serving You From:</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Monday-Saturday </Typography>
                  <Divider/>
                  <Typography variant="h3">10am - 9pm</Typography>
                </Grid>
                <Grid size={{xs: 6}} sx={{textAlign: 'center', margin: 'auto'}}>
                  <Typography variant="body2">Sunday</Typography>
                  <Divider/>
                  <Typography variant="h3">10am - 7pm</Typography>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="body1" sx={{textAlign: 'center', color: "#ffd350"}}>Westshore</Typography>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Typography variant="body1">Call In: &nbsp;</Typography>
              <Link underline='hover' variant='body1' component='a' href="tel:778-440-4010" sx={{textAlign: 'center', color: "#ffd350"}}>778-440-4010</Link>
            </Box>
            <Divider variant="middle" sx={{mb: 2}}>
              <StyledButton 
                onClick={() => 
                  {
                    setSelectedLocation('Westshore')
                    setOrderType('pickup')
                  }
                }                
                fullWidth={false}
                endIcon={<StyledSvgIcon component={ToastLogo} viewBox="0 0 1498 1464" sx={{fontSize: theme.typography.button}}/>}
                variant='contained' 
                size="large"
              >
                Order Pickup
              </StyledButton>
            </Divider>
            <Divider variant="middle">
              <StyledButton
                onClick={() => 
                  {
                    setSelectedLocation('Westshore')
                    setOrderType('delivery')
                  }
                }                
                fullWidth={false}
                endIcon={<StyledSvgIcon component={UberLogo} viewBox="219.8 0 160.4 159.9"/>}
                variant='contained' 
                size="large"
              >
                Order Delivery
              </StyledButton>
            </Divider>
          </Grid>
      
        </Grid>
      </Box>
    
    <StyledDialog
      open={!!selectedLocation}
      dialogTitle='Confirm location'
      onClose={() => {setSelectedLocation(null)}}
      maxWidth="md"
      // fullWidth={true}
    >
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography variant="body2" sx={{textAlign: 'center'}}>
          You have selected the <Typography variant="h2">{selectedLocation}</Typography> location
        </Typography>
          {
            orderType === 'pickup'
              &&
            <StyledButton 
              fullWidth={false}
              endIcon={<StyledSvgIcon component={ToastLogo} viewBox="0 0 1498 1464"/>}
              variant='contained' 
              href={
                selectedLocation === 'Admirals' ?'https://order.toasttab.com/online/gyrosa-102-1517-admirals-road'
                  : selectedLocation === 'Royal Oak' ? 'https://order.toasttab.com/online/gyrosa-saanich'
                  : selectedLocation === 'Westshore' ? 'https://order.toasttab.com/online/gyrosa-langford-101-2945-jacklin-road'
                  : '' // no-op, 'default' case to satisfy ternary

              } 
              target='_blank'
              size="large"
            >
              Pickup from {selectedLocation}
            </StyledButton>
          }

          {
            orderType === 'delivery'
              &&
            <StyledButton 
              fullWidth={false}
              endIcon={<StyledSvgIcon component={UberLogo} viewBox="219.8 0 160.4 159.9" />}
              variant='contained' 
              href={
                selectedLocation === 'Admirals' ?'https://www.ubereats.com/ca/store/gyrosa-fresh-greekadmirals-rd/QHffwYxqUKKQkYSMtvMZVw?diningMode=DELIVERY'
                  : selectedLocation === 'Royal Oak' ? 'https://www.ubereats.com/ca/store/gyrosa-fresh-greekroyal-oak/mPD1N7H2Xe6hZv3NJo_mSA?diningMode=DELIVERY'
                  : selectedLocation === 'Westshore' ? 'https://www.ubereats.com/ca/store/gyrosa-fresh-greek-westshore/ZUwkaLpqWUucWxMl6vGpSw?diningMode=DELIVERY'
                  : '' // no-op, 'default' case to satisfy ternary

              } 
              target='_blank'
              size="large"
            >
              Delivery from {selectedLocation}
            </StyledButton>
          }
      </Box>
    </StyledDialog>
    </>
  )
}
